import React from 'react'
import { LinkAccounts } from '@layerfi/components'
import { useNavigate } from 'react-router-dom'

import './styles.scss'

export function LinkAccountsPage() {
  const navigate = useNavigate()

  return (
    <div className='LinkAccountsPage'>
      <div className='LinkAccountsContainer'>
        <LinkAccounts onComplete={() => navigate('../bank-transactions')} />
      </div>
    </div>
  )
}
